var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPinterestBl(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1680_7725)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.017 0C5.39599 0 0.0289917 5.367 0.0289917 11.987C0.0289917 17.066 3.18699 21.404 7.64699 23.149C7.54199 22.2 7.44799 20.746 7.68799 19.71C7.90699 18.773 9.09399 13.753 9.09399 13.753C9.09399 13.753 8.73499 13.033 8.73499 11.972C8.73499 10.309 9.70199 9.061 10.903 9.061C11.927 9.061 12.421 9.83 12.421 10.749C12.421 11.778 11.768 13.316 11.429 14.741C11.144 15.934 12.029 16.906 13.204 16.906C15.332 16.906 16.972 14.661 16.972 11.419C16.972 8.558 14.909 6.55 11.964 6.55C8.55399 6.55 6.55499 9.112 6.55499 11.749C6.55499 12.782 6.94899 13.892 7.44399 14.49C7.54299 14.61 7.55599 14.715 7.52899 14.835C7.43899 15.21 7.23599 16.034 7.19499 16.198C7.14199 16.423 7.02299 16.469 6.79399 16.363C5.29899 15.673 4.36099 13.485 4.36099 11.717C4.36099 7.941 7.10899 4.465 12.281 4.465C16.439 4.465 19.673 7.432 19.673 11.388C19.673 15.523 17.066 18.85 13.44 18.85C12.226 18.85 11.086 18.221 10.682 17.471L9.93299 20.319C9.66399 21.364 8.92899 22.671 8.43499 23.465C9.55799 23.81 10.741 24 11.985 24C18.592 24 23.97 18.635 23.97 12.013C23.97 5.39 18.592 0.026 11.985 0.026L12.017 0Z",
    fill: "#2C2C2C"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1680_7725"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPinterestBl);
export default __webpack_public_path__ + "static/media/pinterestBl.158537f40fc3a12cb78352f6cf7059bf.svg";
export { ForwardRef as ReactComponent };